/* src/app/catex/catex.component.css */
.header-style {
  text-align: center;
  margin-top: 40px;
  font-family: "Times New Roman";
  font-size: 24px;
  font-weight: bold;
}
.catex-grid {
  border-collapse: collapse;
  border-spacing: 0;
  border-color: #ccc;
}
.catex-grid td {
  text-align: left;
  font-family: Arial, sans-serif;
  font-size: 14px;
  padding: 10px 5px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  word-break: normal;
  border-color: #ccc;
  color: #333;
  background-color: #fff;
}
table.catex-explanation tr,
table.catex-explanation td {
  border: none;
  vertical-align: top;
}
table.catex-explanation {
  margin-left: 12px;
  border-collapse: collapse;
  border: none;
}
.completed-by,
.signature,
.title {
  float: left;
}
.date-label,
.completed-by,
.title-label {
  font-size: 10pt;
}
.signature,
.title {
  margin: 10px;
  border-bottom: 1px solid #000;
  width: 4in;
  display: inline-block;
}
.concordance {
  margin: 10px;
  border-bottom: 1px solid #000;
  width: 3in;
  display: inline-block;
}
.date {
  margin: 10px;
  border-bottom: 1px solid #000;
  width: 1.25in;
  display: inline-block;
}
.field-pre {
  display: block;
  white-space: pre-wrap;
  margin-top: 0px;
  margin-bottom: 8px;
}
/*# sourceMappingURL=catex.component.css.map */
